import { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { sendMessageSocket } from "../../redux/features/chat/chatSocketHandlers";
import uploadFiles from "../../utils/uploadFile";

const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

const ChatInput = ({ userId, role }) => {
  const { activeChat } = useSelector((s) => s.chat.chat);
  const [text, setText] = useState("");

  const [attachments, setAttachments] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    const validFiles = [];

    for (let file of files) {
      if (!file.type) continue;

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`${file.name} exceeds 1MB`);
        continue;
      }

      const isAllowed =
        file.type.startsWith("image/") ||
        file.type.startsWith("video/") ||
        file.type.includes("pdf") ||
        file.type.includes("zip");

      if (!isAllowed) {
        toast.error(`${file.name} is not a supported format`);
        continue;
      }

      validFiles.push({
        file,
        preview:
          file.type.startsWith("image/") || file.type.startsWith("video/")
            ? URL.createObjectURL(file)
            : null,
        type: file.type.startsWith("image/")
          ? "image"
          : file.type.startsWith("video/")
            ? "video"
            : "file",
      });
    }

    setAttachments((prev) => [...prev, ...validFiles]);
    e.target.value = "";
  };

  const removeAttachment = (index) => {
    const item = attachments[index];
    if (item.preview) URL.revokeObjectURL(item.preview);

    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

const sendMessage = async () => {
  if (!activeChat) return;
  if (!text.trim() && attachments.length === 0) return;

  let media = [];

  try {
    // upload ALL files in ONE API call
    if (attachments.length > 0) {
      const files = attachments.map((a) => a.file);
      const res = await uploadFiles(files,role);

      if (res?.success && res.data) {
        media = res?.data || ""
      }
    }

    // decide message type
    let message_type = "text";
    if (media.length && text) message_type = "text_media";
    else if (media.length) message_type = "media";

    // emit ONE socket message
    sendMessageSocket({
      receiver_id: activeChat.opposite_user.id,
      message_type,
      message_text: text,
      media,
    });

    // cleanup
    attachments.forEach((a) => a.preview && URL.revokeObjectURL(a.preview));
    setText("");
    setAttachments([]);
  } catch (err) {
    toast.error("Failed to send message");
  }
};


  return (
    <>
      {attachments.length > 0 && (
        <div className="ct_uploaded_preview_img">
          {attachments.map((item, index) => (
            <>
              <div className="position-relative">
                {item.type === "image" && (
                  <img src={item.preview} alt="preview" />
                )}

                {item.type === "video" && (
                  <video width="60" height="60" controls>
                    <source src={item.preview} />
                  </video>
                )}

                {item.type === "file" && (
                  <div className="pdf">
                    <div className="text-center">
                      <i class="fa-regular fa-file-zipper text-center"></i>
                      <p
                        className="mb-0 ct_fs_12 ct_overlay_text text-center"
                        style={{ maxWidth: "63px" }}
                      >
                        {item.file.name}
                      </p>
                    </div>
                  </div>
                )}
                <i
                  class="fa-regular fa-trash-can ct_delete_img_icon"
                  onClick={() => removeAttachment(index)}
                ></i>
              </div>
            </>
          ))}
        </div>
      )}
      <div class="send-box ">
        <form
          action=""
          class="position-relative"
          onSubmit={(e) => {
            e.preventDefault();
            sendMessage();
          }}
        >
          {/* <label for="ct_chat_img_upload" className="ct_input_icon_left">
            <input
              type="file"
              id="ct_chat_img_upload"
              className="d-none"
              accept="image/*,video/*,.pdf,.zip"
              onChange={handleFileChange}
            />
            <i class="fa-solid fa-paperclip  ct_cursor_pointer"></i>
          </label> */}
          <textarea
            className="form-control h-auto py-3 ct_para_scroll ct_custom_scroll "
            style={{ minHeight: "48px", maxHeight: "58px" }}
            value={text}
            onChange={(e) => setText(e.target.value)}
            data-placeholder="Your message"
          ></textarea>
          <div class="ct_right_side_send_chat_btns ct_cursor_pointer me-2" onClick={sendMessage}>
            Send <i class="fa-solid fa-paper-plane"></i>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChatInput;
